<template>
    <div>
        <div class="card" v-if="!loading">
            <div class="card-header">
                <i class="fa fa-check-square-o" aria-hidden="true"></i> {{ $t('checklist.list') }}
                <div class="card-actions">
                    <a style="cursor: pointer" v-permission="$permissions.CREATE_CHECKLIST" @click="addChecklist()"
                        v-b-tooltip.hover :title="$t('checklist.create')">
                        <small class="text-muted">
                            <i class="fa fa-plus-square action-icon" style="font-size: 18px;"></i></small>
                    </a>
                </div>
            </div>
            <div class="card-body p-1">
                <div style="display: flex;">
                    <div class="col-md-3 pr-1">
                        <div class="input-group">
                            <input size="4" type="text" v-model='search' class="form-control" id="exampleInputAmount"
                                :placeholder="$t('checklist.attribute.search')">
                        </div>
                    </div>
                    <div class="col-md-1 pr-0 pl-0">
                        <div class="input-group">
                            <select name="" id="" class="form-control" v-model='sort'>
                                <option value="desc">{{ $t('filter.sort.desc') }}</option>
                                <option value="asc">{{ $t('filter.sort.asc') }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-1 pr-0 pl-1">
                        <div class="input-group">
                            <select name="" id="" class="form-control" v-model='status'>
                                <option value="">{{ $t('filter.status') }}</option>
                                <option :value="key" v-for="(status, key) in options" :key="key">{{ status }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2 pr-0 pl-1">
                        <div class="input-group">
                            <treeselect :multiple="false" :flatten-search-results="true" :options="category"
                                :normalizer="normalizer" :placeholder="$t('filter.category')" v-model="ctg_value"
                                :default-expand-level="3" />
                        </div>
                    </div>
                    <div class="col-md-3 pr-0 pl-1">
                        <div class="input-group">
                            <treeselect v-if='!loading' :multiple="false" :options="organizations"
                                :normalizer="normalizer" :placeholder="$t('filter.organization')"
                                v-model="organization_id" :default-expand-level="10" />
                        </div>
                    </div>
                    <div class="col-md-1 pr-0 pl-1">
                        <button type="button" @click='filter' class="btn btn-primary col-md-12"><i
                                class="fa fa-filter"></i>
                            {{ $t('filter.filter') }}</button>
                    </div>
                </div>
                <div class="mb-0 table-outline table-responsive" style="min-height: 300px">
                    <table aria-busy="false" aria-colcount="6" class="table b-table table-hover">
                        <!---->
                        <!---->
                        <thead class="thead-light">
                            <tr>
                                <th class="text-center">ID</th>
                                <!-- <th class="">{{$t('checklist.attribute.name')}}</th> -->
                                <th class="text-center">Tên cuộc đánh giá</th>
                                <th class="text-center">{{ $t('checklist.attribute.view_user') }}</th>
                                <th class="text-center">{{ $t('checklist.attribute.organization') }}</th>
                                <th>{{ $t('checklist.attribute.status') }}</th>
                                <th class="text-center">{{ $t('checklist.attribute.action') }}</th>
                            </tr>
                        </thead>
                        <!---->
                        <tbody class="">
                            <!---->
                            <tr class="" v-for="(checklist, key) in checklists" style="cursor: pointer" :key="key">
                                <td @click="view(checklist)">{{ checklist.id }}</td>
                                <td style="width: 30%" @click="view(checklist)">
                                    <div>
                                        <div><i class="fa fa-check-square-o"></i> {{ checklist.name }}</div>
                                        <!-- <div v-if="checklist.status && checklist.status.code == 4">
                          <div class="small text-muted">
                            <span>
                              {{$t('checklist.attribute.starting_date')}}: {{$moment(checklist.start_corrective_date).format('D-M-Y')}}
                            </span>
                          </div>
                          <div class="small text-muted">
                            <span>
                              {{$t('checklist.attribute.ending_date')}}: {{$moment(checklist.end_corrective_date).format('D-M-Y')}}
                            </span>
                          </div>
                        </div> -->
                                        <div>
                                            <div class="small text-muted">
                                                <span>
                                                    {{ $t('checklist.attribute.starting_date') }}:
                                                    {{ $moment(checklist.starting_date).format('D-M-Y') }}
                                                </span>
                                            </div>
                                            <div class="small text-muted">
                                                <span>
                                                    {{ $t('checklist.attribute.ending_date') }}:
                                                    {{ $moment(checklist.ending_date).format('D-M-Y') }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <span @click="viewInfo(checklist)" class="link"><i class="fa fa-eye"></i> Thông tin
                                        đoàn đánh giá </span>
                                </td>
                                <td @click="view(checklist)">
                                    {{ checklist.organization ? checklist.organization.name : '' }}
                                </td>
                                <td>
                                    <status :status.sync="checklist.status" :options.sync="options"
                                        @approval="approval(checklist)" @rejection="rejection(checklist)"
                                        @close="close(checklist)" @corrective="corrective(checklist)"
                                        @inProgress="inProgress(checklist)" />
                                </td>
                                <td>
                                    <b-dropdown variant="link" size="md" no-caret v-b-tooltip.hover
                                        :title="$t('user.attribute.action')">
                                        <template slot="button-content">
                                            <i class="fa fa-bars"></i>
                                        </template>
                                        <b-dropdown-item @click="view(checklist)"><i
                                                class="fa fa-pencil"></i>{{ $t('checklist.attribute.auditing') }}</b-dropdown-item>
                                        <b-dropdown-item @click="_reportFix(checklist)"
                                            v-if="parseInt(checklist.status.code) == 4 || parseInt(checklist.status.code) == 5"><i
                                                class="fa fa-bug" aria-hidden="true"></i>
                                            {{ $t('summary.result_corrective') }}</b-dropdown-item>
                                        <b-dropdown-item v-permission="$permissions.ADD_CHECKLIST_ITEM"
                                            @click="addChecklistItem(checklist)"><i
                                                class="fa fa-plus"></i>{{ $t('checklist.attribute.add_checklist_item') }}</b-dropdown-item>
                                        <b-dropdown-item @click="printChecklist(checklist)"><i class="fa fa-print"
                                                aria-hidden="true"></i>In kết quả đánh
                                            giá</b-dropdown-item>
                                        <b-dropdown-item v-permission="$permissions.UPDATE_CHECKLIST"
                                            @click="edit(checklist)"><i
                                                class="fa fa-edit"></i>{{ $t('checklist.attribute.edit') }}</b-dropdown-item>
                                        <b-dropdown-item v-permission="$permissions.DELETE_CHECKLIST"
                                            @click="destroy(checklist)"><i
                                                class="fa fa-remove"></i>{{ $t('checklist.attribute.delete') }}</b-dropdown-item>
                                    </b-dropdown>
                                </td>
                            </tr>
                            <!---->
                            <!---->
                        </tbody>
                    </table>
                </div>
                <div class="pt-3">
                    <select name="per_page" v-model='per_page' required="required" @change="changeTotal">
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                    </select>
                    {{ $t('paginate.count') }} {{ total }} {{ $t('paginate.row') }}
                    <paginate :page-count="last_page" :click-handler="changePage" :prev-text="$t('paginate.prev')"
                        :next-text="$t('paginate.next')" :container-class="'pagination'" class="pull-right">
                    </paginate>
                </div>
            </div>
        </div>
        <div v-else class="card">
            <div class="card-body text-center">
                <div class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <close ref="close" @closeSuccess="closeSuccess"></close>
        <!-- <corrective ref = "corrective" @correctiveSuccess = "correctiveSuccess"></corrective> -->
        <AssessmentTeam ref="viewInfo" class="text-center"/>
        <div class="page" id="page" v-show="false">
            <div class="header row" style="border-bottom: black solid 2px">
                <div class="col-md-6">
                    <img src="/static/petrolimexaviation.jpg" class="img-responsive" alt="Image" style="width: 349px">
                </div>
                <div class="col-md-6">
                    <span class="pull-right text-uppercase" style="font-weight: bold;">
                        {{ $t('summary.audit_result') }}
                    </span>
                </div>
            </div>
            <div class="body row mt-3">
                <div class="col-md-12 text-center text-uppercase">
                    <b>{{ $t('summary.detail_audit_result') }}</b>
                </div>
            </div>
            <div class="row mt-3 mr-1 ml-1" v-for="(item, key) in data_print" :key="key">
                <p><b>{{ item.group.index }} - {{ item.group.header }}</b></p>
                <div class="table-responsive" v-if="item.chk_item.length != 0">
                    <table class="table table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th>ID</th>
                                <th>{{ $t('checklist-item.attribute.content') }}</th>
                                <th>{{ $t('summary.refer') }}</th>
                                <th>{{ $t('checklist-item.attribute.status') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(chk_item, key) in item.chk_item" :key="key">
                                <td style="width: 10%">{{ chk_item.header }}</td>
                                <td style="width: 70%">
                                    <span v-html="chk_item.content"></span><br>
                                    <!-- <div class="mb-5">
                        <b>Comment :</b>
                      </div> -->
                                </td>
                                <td>
                                    <span v-for="(doc, key) in chk_item.document_items" :key="key">{{ doc.index }}
                                        ({{ doc.document ? doc.document.name : '' }})<br></span>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Paginate from 'vuejs-paginate'
import Status from '@/components/status'
import swal from 'sweetalert'
import Close from './close'
import AssessmentTeam from './assessmentTeam'
import lodash from 'lodash'
import StatusCode from '@/status'
export default {
  name: 'list',
  components: { Paginate, Status, Close, AssessmentTeam },
  props: [],
  data () {
    return {
      per_page: 20,
      sort: 'desc',
      status: '',
      search: '',
      ctg_value: null,
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      organization_id: null,
      loading: false,
      data_print: []
    }
  },
  computed: {
    category () {
      return this.$store.getters['CategoryChk/getListRecursive']
    },
    checklists () {
      return this.$store.getters['Checklist/getListChecklist']
    },
    last_page () {
      return this.$store.getters['Checklist/getLastPage']
    },
    total () {
      return this.$store.getters['Checklist/getTotal']
    },
    options () {
      return this.$store.getters['Status/getStatusChecklist']
    },
    fields () {
      return this.$store.getters['Checklist/getField']
    },
    checklist_item_status () {
      return this.$store.getters['ChecklistItemStatus/getListStatus']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    }
  },
  mounted () {
    this.loading = true
    Promise.all([
      this.$store.dispatch('Checklist/getListChecklist', { page: 1, per_page: 20, sort: 'desc' }),
      this.options.length === 0 ? this.$store.dispatch('Status/getListStatus') : '',
      this.organizations.length === 0 ? this.$store.dispatch('Organization/getData', { page: 1, per_page: 'all' }) : '',
      this.checklist_item_status.length === 0 ? this.$store.dispatch('ChecklistItemStatus/getListStatus') : '',
      this.category.length === 0 ? this.$store.dispatch('CategoryChk/getListCtg') : ''
    ]).then(res => {
      // this.organizations = res[2]

      this.loading = false
    }).catch(errors => {
      this.loading = false
    })
  },
  methods: {
    addChecklist () {
      this.$router.push('create')
    },
    changeTotal () {
      this.$store.dispatch('Checklist/getListChecklist', { page: 1, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id }).then(res => {

      }).catch(errors => {

      })
    },

    changePage (page) {
      this.$store.dispatch('Checklist/getListChecklist', { page: page, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id }).then(res => {

      }).catch(errors => {

      })
    },

    edit (checklist) {
      this.$router.push(checklist.id + '/edit')
    },

    addChecklistItem (checklist) {
      if (parseInt(checklist.status.code) !== parseInt(StatusCode.SUBMITTING)) {
        swal({
          title: this.$t('checklist.error.add_group_checklist_item.title'),
          text: this.$t('checklist.error.add_group_checklist_item.text') + checklist.status.name,
          icon: 'warning'
        })
      } else {
        this.$router.push(checklist.id + '/checklist-item')
      }
    },

    view (checklist) {
      this.$router.push(checklist.id + '/view')
    },

    destroy (checklist) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$store.dispatch('Checklist/destroyChecklist', {
              checklist
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
            }).catch(errors => {

            })
          }
        })
    },

    approval (checklist) {
      this.$store.dispatch('Checklist/approvalChecklist', { checklist }).then(res => {
        checklist.status = res.status
      }).catch(errors => {

      })
    },
    rejection (checklist) {
      this.$store.dispatch('Checklist/rejectChecklist', { checklist }).then(res => {
        checklist.status = res.status
      }).catch(errors => {

      })
    },
    close (checklist) {
      if (parseInt(StatusCode.CLOSE) === parseInt(checklist.status.code)) {
        return false
      }
      this.$refs.close.show(checklist)
    },
    closeSuccess (checklist) {
      var index = lodash.findIndex(this.checklists, ['id', checklist.id])
      this.checklists.splice(index, 1, checklist)
      this.$notify({
        group: 'success',
        title: this.$t('notify.notify'),
        text: this.$t('notify.update_success')
      })
      this.$refs.close.hide()
    },
    corrective (checklist) {
      if (parseInt(StatusCode.CORRECTIVE) === parseInt(checklist.status.code)) {
        return false
      }
      // this.$refs.corrective.show(checklist)
      this.$router.push('/checklist/' + checklist.id + '/corrective')
    },
    correctiveSuccess (checklist) {
      var index = lodash.findIndex(this.checklists, ['id', checklist.id])
      this.checklists.splice(index, 1, checklist)
      this.$notify({
        group: 'success',
        title: this.$t('notify.notify'),
        text: this.$t('notify.update_success')
      })
      this.$refs.corrective.hide()
    },
    inProgress (checklist) {
      this.$store.dispatch('Checklist/inProgressChecklist', { checklist }).then(res => {
        checklist.status = res.status
      }).catch(errors => {

      })
    },
    filter () {
      this.$store.dispatch('Checklist/getListChecklist', { page: 1, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id, ctg: this.ctg_value }).then(res => {

      }).catch(errors => {

      })
    },
    viewInfo (checklist) {
      this.$refs.viewInfo.show(checklist)
    },
    _reportFix (checklist) {
      this.$router.push('/checklist/' + checklist.id + '/corrective-result')
    },
    async printChecklist (checklist) {
      await this.$store.dispatch('Audit/getChecklistItemOfChecklist', { checklist }).then(res => {
        this.data_print = res

        this.$nextTick(() => {
          var innerContents = document.getElementById('page').innerHTML
          var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
          popupWinindow.document.open()
          popupWinindow.document.write('<html><head><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
          popupWinindow.document.close()
        })
      }).catch(errors => {
        console.log(errors)
      })
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/checklist/list/index.vue